import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import api from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [balance, setBalance] = useState(0);

  const fetchData = () => {
    api.get('/messages/stats').then(r => setStats(r.data));
    api.get('/credits/balance').then(r => setBalance(r.data.credits));
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000); // refresh every 30 sec
    return () => clearInterval(interval);
  }, []);

  const formatChartDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return String(d.getDate()).padStart(2,'0') + '-' + String(d.getMonth()+1).padStart(2,'0');
  };

  if (!stats) return <div style={{padding:'40px',color:'#888'}}>Loading...</div>;

  return (
    <div>
      <div className="cards">
        <div className="card blue">
          <div className="label">Total Sent</div>
          <div className="value">{stats.total}</div>
        </div>
        <div className="card green">
          <div className="label">Delivered</div>
          <div className="value">{stats.delivered}</div>
        </div>
        <div className="card purple">
          <div className="label">Read</div>
          <div className="value">{stats.read}</div>
        </div>
        <div className="card red">
          <div className="label">Failed</div>
          <div className="value">{stats.failed}</div>
        </div>
        <div className="card orange">
          <div className="label">Today Sent</div>
          <div className="value">{stats.today}</div>
        </div>
        <div className="card green">
          <div className="label">Total Balance</div>
          <div className="value">₹{parseFloat(balance).toFixed(2)}</div>
        </div>
      </div>

      <div className="box">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
          <h3 style={{marginBottom:0}}>Last 10 Days — Message Activity</h3>
          <span style={{fontSize:'12px',color:'#aaa'}}>Auto refreshes every 30s</span>
        </div>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={stats.chart}>
            <XAxis dataKey="date" tickFormatter={formatChartDate} tick={{fontSize:11}} />
            <YAxis allowDecimals={false} />
            <Tooltip labelFormatter={formatChartDate} />
            <Legend />
            <Line type="monotone" dataKey="sent" stroke="#1a73e8" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="delivered" stroke="#34a853" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="read_count" stroke="#9c27b0" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="failed" stroke="#ea4335" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
